import isItemView from 'owa-mail-store/lib/utils/isItemView';
import { lazyMoveSelectedConversations, lazyMoveSelectedItems } from 'mini-mail-triage-actions';

export const moveSelectedRows = (folderIdToMove: string) => {
    isItemView()
        ? lazyMoveSelectedItems(folderIdToMove)
        : lazyMoveSelectedConversations(folderIdToMove);
};
